// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c70d8bf8","703":"75389024","787":"f6a044b0"}[chunkId] + ".chunk.js";
};